import n from"@formkit/auto-animate";import{createEffect as o}from"solid-js";function m(t,i){o(()=>{let e=i();n(t,e===!0?{}:e)})}function r(t,i){o(()=>{n(t(),i)})}export{m as autoAnimate,r as useAutoAnimate};
